// Configuration file for API endpoints
const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT || '/backend';

export default API_BASE_URL;
export { BACKEND_ENDPOINT }; 